export type EnergyHarbourCustomer = {
    name: string;
    companyId: string | undefined;
    companyDepartmentId: number | undefined;
}

export function EnergyHarbourCustomer_normalize(customer: EnergyHarbourCustomer): EnergyHarbourCustomer {
    return {
        name: customer.name ?? "",
        companyId: customer.companyId,
        companyDepartmentId: customer.companyDepartmentId
    }
}